import React, { useEffect, useState } from "react";
import "./Plan_Purchase.css";
import Second_Header from "../Common_Component/Second_Header/Second_Header";
import Plan_Purchase_content_header from "./Plan_Purchase_content/Plan_Purchase_content_header/Plan_Purchase_content_header";
import Plan_Purchase_step_form from "./Plan_Purchase_content/Plan_Purchase_step_form/Plan_Purchase_step_form";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
const Plan_Purchase = () => {
  const [activeStepIndex, setActiveStepIndex] = useState(0); // Track current step

  const steps = [
    "Life Cover",
    "Cover till age",
    // "Pay for",
    "Mode of premium payment",
  ];
  const location = useLocation();
  const val = location.state?.val;

  const [data, setData] = useState(false);
  const user_data = Cookies.get("user_data"); // Get the value of 'status' cookie

  useEffect(() => {
    if (user_data) {
      const parsedData = JSON.parse(user_data);
      setData(parsedData);
    }
  }, [user_data]);
  return (
    <section className="Plan_Purchase">
      <Second_Header setData={setData} data={data} />

      <div className="container">
        {/* Pass hideActionLinks as true only for the last step */}
        <Plan_Purchase_content_header
          val={val}
          hideActionLinks={activeStepIndex === steps.length - 1}
          setActiveStepIndex={setActiveStepIndex}
        />

        <Plan_Purchase_step_form
          insurance={val}
          data={data}
          activeStepIndex={activeStepIndex}
          setActiveStepIndex={setActiveStepIndex}
          steps={steps}
        />
      </div>
    </section>
  );
};

export default Plan_Purchase;
